<div class="trezo-card bg-white dark:bg-[#0c1427] mb-[25px] p-[20px] md:p-[25px] rounded-md">
    <div class="trezo-card-header mb-[20px] md:mb-[25px] flex items-center justify-between">
        <div class="trezo-card-title">
            <h5 class="!mb-0">
                Profile Information
            </h5>
        </div>
    </div>
    <div class="trezo-card-content">
        <ul>
            <li class="mb-[12.5px] last:mb-0">
                User ID:
                <span class="text-black dark:text-white font-medium">
                    7001
                </span>
            </li>
            <li class="mb-[12.5px] last:mb-0">
                Full Name:
                <span class="text-black dark:text-white font-medium">
                    Olivia John
                </span>
            </li>
            <li class="mb-[12.5px] last:mb-0">
                Email:
                <span class="text-black dark:text-white font-medium">
                    olivia&#64;trezo.com
                </span>
            </li>
            <li class="mb-[12.5px] last:mb-0">
                Role:
                <span class="text-black dark:text-white font-medium">
                    Administrator
                </span>
            </li>
            <li class="mb-[12.5px] last:mb-0">
                Location:
                <span class="text-black dark:text-white font-medium">
                    New York, USA
                </span>
            </li>
            <li class="mb-[12.5px] last:mb-0">
                Join Date:
                <span class="text-black dark:text-white font-medium">
                    10 May 2022
                </span>
            </li>
        </ul>
    </div>
</div>